<template>
  <div class="header">
    <div class="name">
      <h3>我的成绩</h3>
    </div>
  </div>
  <template v-if="myScore">
    <div class="score_content">
      <h2>湖北日报传媒集团2024年专项招聘</h2>
      <p>
        <span>姓名</span>：<b>{{ myScore.name }}</b>
      </p>
      <p>
        <span>报考岗位</span>：<b>{{ myScore.jobName }}</b>
      </p>
      <p>
        <span>身份证号</span>：<b>{{ myScore.idNumber }}</b>
      </p>
      <p>
        <span>准考证号</span>：<b>{{ myScore.examNumber }}</b>
      </p>
      <p>
        <span>成绩</span>：<b>{{ myScore.score ? myScore.score : '0' }}</b>
      </p>
    </div>
  </template>
  <el-empty v-else :image-size="140" description="无数据"></el-empty>
</template>
<script>
export default {
  name: 'Score',
};
</script>

<script setup>
import { onActivated, ref, watch, computed } from 'vue';
import { useStore } from 'vuex';
import ApplicantApi from '../service/api/applicant';

const myScore = ref(null);

const store = useStore();
const userInfo = computed(() => store.state.userInfo);
const activityId = computed(() => store.state.currentBatch?.activityId);

const init = async () => {
  if (!userInfo.value || !userInfo.value.basicId) return;
  if (!activityId.value) return;
  try {
    const res = await ApplicantApi.findWrittenExamScore({
      activityId: activityId.value,
      basicId: userInfo.value.basicId,
    });
    if (res.examNumber) {
      myScore.value = res;
    }
  } catch (e) {
    myScore.value = null;
  }
};
watch([() => store.state.userInfo, () => store.state.currentBatch], init);
onActivated(init);
</script>

<style lang="scss" scoped>
@import '../style/func.scss';
.header {
  border-bottom: 1px solid rgba(112, 112, 112, 0.1);
  box-shadow: 0 0 4px #bebebe;
  padding: 10px 10px 6px 10px;
  font-size: 16px;
  .name {
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  h3 {
    flex: 1;
    padding: 0 30px;
    white-space: nowrap;
  }
}
.score_content {
  width: 500px;
  margin: rem(150px) auto rem(50px);
  font-size: rem(15px);
  box-shadow: 0 0 4px #bebebe;
  padding-bottom: rem(50px);
  h2 {
    margin-bottom: rem(30px);
    text-align: center;
    background: #4784e3;
    color: #fff;
    line-height: rem(50px);
    font-size: rem(22px);
  }
  p {
    line-height: rem(30px);
    color: #666;
    margin-left: rem(130px);
    span {
      width: rem(66px);
      display: inline-block;
      text-align: justify;
      text-align-last: justify;
    }
    b {
      margin-left: 10px;
      color: #000;
      font-size: 16px;
      font-weight: bold;
      font-family: 'Microsofe YaHei', 'Arial';
    }
  }
}
@media screen and (max-width: 600px) {
  .score_content {
    width: 90%;
    margin: rem(50px) auto;
    h2 {
      font-size: rem(18px);
    }
    p {
      margin-left: rem(50px);
    }
  }
}
</style>
